import Alpine from "alpinejs";
import Toolkit from "@alpine-collective/toolkit";
import persist from "@alpinejs/persist";
import mask from "@alpinejs/mask";
import SeatMap from "./seatMap";
import TwoDSeatMap from "./TwoDSeatMap";
window._ = require("lodash");

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require("axios");
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
window.FilePond = require("filepond");
window.FilePond.registerPlugin(require("filepond-plugin-file-validate-type"));
window.FilePond.registerPlugin(require("filepond-plugin-file-validate-size"));

window.Popper = require("@popperjs/core");
window.Tippy = require("tippy.js");
window.Flickity = require("flickity");
window.SeatMap = SeatMap;
window.TwoDSeatMap = TwoDSeatMap;

window.Alpine = Alpine;

Alpine.plugin(mask);
Alpine.plugin(persist);
Alpine.plugin(Toolkit);

Alpine.start();
